import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function SpecialCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const fullName =
      /^[A-Za-záàâãäéèêëíïóôõöúüçñÁÀÂÃÄÉÈËÍÏÓÔÕÖÚÜÇÑ']+(?: [A-Za-záàâãäéèêëíïóôõöúüçñÁÀÂÃÄÉÈËÍÏÓÔÕÖÚÜÇÑ']+)+$/.test(
        value
      );

    return !fullName
      ? {
          fullName: {
            valid: false,
          },
        }
      : null;
  };
}
